<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'App',
  data () {
    return {}
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    })
  },
  created: function () {
    if (!this.config) {
      this.fetchConfig({}).then(
        res => {
          if (res.code == 10000) {
            document.title = res.result.config_list.site_name
          } else {
            Toast(res.message)
          }
        },
        error => {
          Toast(error.message)
        }
      )
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    })
  }
}
</script>
<style lang="scss">
.preview figure {
  float: left;
  width: 80px;
  height: 80px;
  margin: 0 6px 6px 0;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  display:-webkit-box;
  -webkit-box-align:center;
}
.preview figure img {
  width: 100%;
  height: 100%;
}
.preview.has_video figure:first-child{
  margin-left: 86px;
}
</style>